import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=47bbf739&scoped=true&"
var script = {}
import style0 from "./Introduce.vue?vue&type=style&index=0&id=47bbf739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbf739",
  null
  
)

export default component.exports